/* NK i18n — version néerlandaise des textes écrits en dur dans les sections sur mesure.
   Chargé UNIQUEMENT quand la langue de la page est le néerlandais (voir nk-lang.liquid) :
   aucun coût pour les autres langues. Même moteur que nk-i18n.js (anglais).

   • DICT : correspondance exacte (texte nettoyé des espaces) français → néerlandais.
   • RULES : motifs avec nombres ou dates (« 44 modèles », « lun. 28 sept. »…).
   Les noms de marques et de modèles ne sont jamais touchés ; les descriptions
   produits (traduites dans Shopify) sont exclues.
   Un MutationObserver traduit aussi ce qui apparaît après coup
   (tiroir panier, pack, paliers, livraison estimée…).
   Pour ajouter un texte : une ligne "français": "nederlands" dans DICT. */
(function () {
  if (window.__nkI18n) return;
  window.__nkI18n = true;

  var DICT = {
    "Livraison rapide en France": "Snelle levering in Frankrijk",
    "Livraison rapide dans le monde entier": "Snelle levering wereldwijd",
    "Paiement sécurisé & flexible": "Veilig & flexibel betalen",
    "Support en ligne 7j/7": "Online support 7/7",
    "Satisfait ou remboursé": "Tevreden of geld terug",
    "Satisfait ou Remboursé": "Tevreden of Geld Terug",
    "SOLDES DE RENTRÉE": "BACK-TO-SCHOOL SALE",
    "-50% SUR TOUT LE MAGASIN": "-50% OP DE HELE WINKEL",
    "-25% sur la 2e paire": "-25% op het 2e paar",
    "J'en profite": "Ik profiteer",
    "+3 000 clients": "+3.000 klanten",
    "L'HIVER EST LÀ": "DE WINTER IS ER",
    "Doudounes et vestes : Moncler, Canada Goose, Ralph Lauren": "Donsjassen en jassen: Moncler, Canada Goose, Ralph Lauren",
    "Découvrir": "Ontdekken",
    "Bannière 1": "Banner 1",
    "Bannière 2": "Banner 2",
    "Précédent": "Vorige",
    "Suivant": "Volgende",
    "Nos sneakers": "Onze sneakers",
    "Voir plus": "Meer bekijken",
    "Nouveautés bientôt disponibles.": "Nieuwe items binnenkort beschikbaar.",
    "Nos best-sellers": "Onze bestsellers",
    "Tout afficher": "Alles weergeven",
    "Nos collections": "Onze collecties",
    "Chaussures": "Schoenen",
    "Doudounes & Vestes": "Donsjassen & Jassen",
    "Vêtements": "Kleding",
    "Validé par nos ambassadeurs": "Goedgekeurd door onze ambassadeurs",
    "Ils partagent leur expérience": "Zij delen hun ervaring",
    "Couper ou remettre le son": "Geluid aan of uit",
    "À l'affiche": "Uitgelicht",
    "Une saison, un style": "Eén seizoen, één stijl",
    "À chaque saison sa collection": "Elk seizoen zijn collectie",
    "Saison froide": "Koud seizoen",
    "Prêts pour l'hiver": "Klaar voor de winter",
    "Doudounes Moncler, Canada Goose, Ralph Lauren et CP Company. Le chaud qui ne sacrifie rien au style.": "Donsjassen van Moncler, Canada Goose, Ralph Lauren en CP Company. Warmte die niets opoffert aan stijl.",
    "Voir les doudounes": "Bekijk de donsjassen",
    "Entre deux saisons": "Tussenseizoen",
    "La veste qui fait la tenue": "De jas die de outfit maakt",
    "Supreme, Courrèges, Ami Paris : les pièces légères qui portent tout le reste.": "Supreme, Courrèges, Ami Paris: de lichte items die de rest van je outfit dragen.",
    "Voir les vestes": "Bekijk de jassen",
    "Notre histoire": "Ons verhaal",
    "LA CULTURE SNEAKER, SANS COMPROMIS": "SNEAKERCULTUUR, ZONDER COMPROMISSEN",
    "Des icônes d'hier aux drops d'aujourd'hui, chaque paire est sélectionnée à la main. Pas de remplissage — juste des pépites qu'on porterait nous-mêmes.": "Van iconen van toen tot de drops van nu: elk paar wordt met de hand geselecteerd. Geen opvulling — alleen pareltjes die we zelf zouden dragen.",
    "Voir tout le catalogue": "Bekijk de hele catalogus",
    "Nos marques": "Onze merken",
    "Découvrir la collection": "Ontdek de collectie",
    "Depuis le premier drop": "Sinds de eerste drop",
    "La culture sneaker, sans compromis.": "Sneakercultuur, zonder compromissen.",
    "Rejoins le Kicklab": "Word lid van het Kicklab",
    "Crée ton compte pour suivre tes commandes, accéder aux drops en avant-première et ne rien rater des nouveautés.": "Maak je account aan om je bestellingen te volgen, als eerste toegang te krijgen tot drops en geen enkele nieuwigheid te missen.",
    "Créer un compte": "Account aanmaken",
    "Se connecter": "Inloggen",
    "Ne rate pas ça": "Mis dit niet",
    "La collab du moment": "De collab van het moment",
    "L'icône": "Het icoon",
    "Acheter": "Kopen",
    "La voix de nos clients !": "De stem van onze klanten!",
    "Basé sur 512 avis clients": "Gebaseerd op 512 klantreviews",
    "Client Urban Kicklab": "Klant van Urban Kicklab",
    "Achat vérifié": "Geverifieerde aankoop",
    "Avis client Urban Kicklab": "Klantreview Urban Kicklab",
    "Commandé un lundi, reçu le mercredi. La paire est nickel, aucune trace, boîte impeccable.": "Op maandag besteld, woensdag ontvangen. Het paar is perfect, geen sporen, doos in topstaat.",
    "Je cherchais ce modèle depuis des mois, introuvable ailleurs à ce prix. Merci !": "Ik zocht dit model al maanden, nergens anders te vinden voor deze prijs. Bedankt!",
    "Taille parfaitement, j'ai pris ma pointure habituelle sans hésiter.": "Valt perfect, ik heb zonder twijfel mijn gebruikelijke maat genomen.",
    "Taille parfaitement, j’ai pris ma pointure habituelle sans hésiter.": "Valt perfect, ik heb zonder twijfel mijn gebruikelijke maat genomen.",
    "Le SAV répond en quelques minutes, ça change tout quand on hésite sur la taille.": "De klantenservice antwoordt binnen een paar minuten, dat scheelt enorm als je twijfelt over je maat.",
    "Deuxième commande, toujours la même qualité. Je ne vais plus voir ailleurs.": "Tweede bestelling, nog steeds dezelfde kwaliteit. Ik kijk niet meer ergens anders.",
    "Emballage soigné et petit mot dans le colis, ça fait plaisir.": "Zorgvuldig verpakt en een kaartje in het pakket, dat doet plezier.",
    "Au prix payé je m'attendais à moins bien. Très agréablement surpris.": "Voor deze prijs had ik minder verwacht. Heel aangenaam verrast.",
    "Au prix payé je m’attendais à moins bien. Très agréablement surpris.": "Voor deze prijs had ik minder verwacht. Heel aangenaam verrast.",
    "Offerte à mon copain, il ne les quitte plus. Mission réussie.": "Cadeau gedaan aan mijn vriend, hij trekt ze niet meer uit. Missie geslaagd.",
    "Livraison suivie à chaque étape, aucune mauvaise surprise.": "Levering bij elke stap gevolgd, geen onaangename verrassingen.",
    "Les photos du site sont fidèles, la couleur est exactement la même en vrai.": "De foto's op de site kloppen, de kleur is in het echt precies hetzelfde.",
    "Confortables dès le premier jour, zéro temps d'adaptation.": "Comfortabel vanaf de eerste dag, geen inloopperiode.",
    "Confortables dès le premier jour, zéro temps d’adaptation.": "Comfortabel vanaf de eerste dag, geen inloopperiode.",
    "Site sérieux, paiement en plusieurs fois bien pratique. Je recommande.": "Betrouwbare site, in termijnen betalen is erg handig. Aanrader.",
    "Vos Retours": "Jullie Feedback",
    "Vos retours": "Jullie feedback",
    "Guide des tailles": "Maattabel",
    "Nos modèles chaussent normalement.": "Onze modellen vallen normaal.",
    "Prends ta pointure habituelle.": "Neem je gebruikelijke maat.",
    "Prends la taille au-dessus.": "Neem een maat groter.",
    "Comment mesurer ton pied :": "Zo meet je je voet:",
    "pose ton talon contre un mur, debout, et mesure jusqu'au bout de ton orteil le plus long.": "zet je hiel tegen een muur, ga rechtop staan en meet tot het puntje van je langste teen.",
    "Mesure en fin de journée : le pied est légèrement plus large qu'au réveil.": "Meet aan het einde van de dag: je voet is dan iets breder dan 's ochtends.",
    "Correspondances indicatives, variables selon les marques.": "Indicatieve maten, kunnen per merk verschillen.",
    "Pointure": "Maat",
    "Taille": "Maat",
    "Taille:": "Maat:",
    "Taille :": "Maat:",
    "2ème paire à -25% + kit offerts avec le code URBAN25": "2e paar -25% + gratis kit met de code URBAN25",
    "avis": "reviews",
    "Livraison": "Levering",
    "Commande": "Bestelling",
    "Préparation": "Voorbereiding",
    "Expédition": "Verzending",
    "Livraison Offerte": "Gratis Levering",
    "Livraison offerte": "Gratis levering",
    "Retour sous 30 jours": "Retour binnen 30 dagen",
    "0 % d'intérêts": "0% rente",
    "0 % d’intérêts": "0% rente",
    "Paiement sécurisé": "Veilig betalen",
    "Commandé": "Besteld",
    "Expédié": "Verzonden",
    "Livré": "Geleverd",
    "Livraison estimée entre le": "Verwachte levering tussen",
    "et le": "en",
    "Commande maintenant : expédition": "Bestel nu: verzending",
    "Commande dans les": "Bestel binnen",
    ": expédition": ": verzending",
    "aujourd'hui": "vandaag",
    "aujourd’hui": "vandaag",
    "demain": "morgen",
    "lundi": "maandag", "mardi": "dinsdag", "mercredi": "woensdag", "jeudi": "donderdag", "vendredi": "vrijdag", "samedi": "zaterdag", "dimanche": "zondag",
    "Livraison & Retour Gratuit": "Gratis Levering & Retour",
    "Les commandes sont expédiées sous 24 à 72 h. La livraison est ensuite estimée entre 8 et 12 jours après la commande.": "Bestellingen worden binnen 24 tot 72 uur verzonden. De levering wordt daarna geschat op 8 tot 12 dagen na de bestelling.",
    "Le délai total correspond au temps de préparation de votre commande ainsi qu’au temps d’acheminement.": "De totale termijn omvat de voorbereidingstijd van je bestelling en de transporttijd.",
    "Le délai total correspond au temps de préparation de votre commande ainsi qu'au temps d'acheminement.": "De totale termijn omvat de voorbereidingstijd van je bestelling en de transporttijd.",
    "À noter : durant les périodes de fêtes": "Let op: tijdens de feestdagen",
    "de forte affluence, des retards exceptionnels peuvent survenir.": "en drukke periodes kunnen uitzonderlijke vertragingen optreden.",
    "Pas entièrement satisfait ? Vous disposez de 30 jours après réception pour effectuer un retour. Une fois votre article reçu et vérifié, le remboursement est effectué rapidement via votre moyen de paiement initial.": "Niet helemaal tevreden? Je hebt 30 dagen na ontvangst om een retour aan te vragen. Zodra je artikel is ontvangen en gecontroleerd, wordt het bedrag snel terugbetaald via je oorspronkelijke betaalmethode.",
    "RÉSEAUX SOCIAUX": "SOCIAL MEDIA",
    "Nos produits en vidéo": "Onze producten op video",
    "Vrais clients, vraies réactions": "Echte klanten, echte reacties",
    "Vus et portés par notre communauté": "Gezien en gedragen door onze community",
    "Vu sur": "Gezien op",
    "Vu sur TikTok": "Gezien op TikTok",
    "Voir le produit": "Bekijk het product",
    "Voir la collection": "Bekijk de collectie",
    "Lire la vidéo": "Video afspelen",
    "Doudounes Moncler": "Moncler Donsjassen",
    "Doudounes Moncler (unboxing)": "Moncler Donsjassen (unboxing)",
    "Vestes Supreme": "Supreme Jassen",
    "Vestes Courrèges": "Courrèges Jassen",
    "Les marques disponibles sur le site": "De merken op onze site",
    "Les marques disponibles sur Urban Kicklab": "De merken bij Urban Kicklab",
    "AFFICHER PLUS": "MEER WEERGEVEN",
    "Récemment consultés": "Recent bekeken",
    "Articles Consultés Récemment": "Recent Bekeken Artikelen",
    "Vous allez aimer": "Dit vind je vast ook leuk",
    "Photo précédente": "Vorige foto",
    "Photo suivante": "Volgende foto",
    "On vous répond en toute clarté": "Duidelijke antwoorden op je vragen",
    "Questions fréquentes": "Veelgestelde vragen",
    "Quels sont les délais de livraison ?": "Wat zijn de levertijden?",
    "Ta commande est expédiée sous 24 à 72 h, puis livrée en 8 à 12 jours. Tu reçois un numéro de suivi par e-mail dès l'expédition pour suivre ton colis à chaque étape.": "Je bestelling wordt binnen 24 tot 72 uur verzonden en daarna in 8 tot 12 dagen geleverd. Je ontvangt een trackingnummer per e-mail zodra hij verzonden is, zodat je je pakket bij elke stap kunt volgen.",
    "Le paiement est-il sécurisé ?": "Is betalen veilig?",
    "À 100 %. Paiement crypté via les principales cartes bancaires et solutions de paiement. Tes données bancaires ne sont jamais conservées.": "100%. Versleutelde betaling via alle grote bankkaarten en betaalmethoden. Je bankgegevens worden nooit bewaard.",
    "Et si la paire ne me convient pas ?": "En als het paar niet goed is?",
    "Garantie satisfait ou remboursé : contacte notre service client, on organise l'échange de taille ou le remboursement. Tu commandes l'esprit tranquille.": "Tevreden of geld terug: neem contact op met onze klantenservice en wij regelen een ruil van maat of een terugbetaling. Je bestelt met een gerust hart.",
    "Comment contacter le service client ?": "Hoe neem ik contact op met de klantenservice?",
    "Notre équipe est réactive et répond rapidement à toutes tes questions — avant comme après ta commande.": "Ons team reageert snel en beantwoordt al je vragen — vóór en na je bestelling.",
    "Commande en toute confiance": "Bestel met vertrouwen",
    "Expédition 24-48 h": "Verzending binnen 24-48 uur",
    "Expédition 24-72 h": "Verzending binnen 24-72 uur",
    "Commande expédiée rapidement, suivi inclus.": "Snel verzonden, inclusief tracking.",
    "Transactions 100 % cryptées.": "100% versleutelde transacties.",
    "Échange ou remboursement, sans prise de tête.": "Ruilen of terugbetalen, zonder gedoe.",
    "Service client réactif": "Snelle klantenservice",
    "Une question ? On te répond vite.": "Een vraag? We antwoorden je snel.",
    "Les plus regardés en ce moment": "Nu het meest bekeken",
    "Sélection basée sur les pages les plus visitées": "Selectie op basis van de meest bezochte pagina's",
    "Tout voir": "Alles bekijken",
    "Soyez les premiers à être au courant de nos promotions !": "Wees als eerste op de hoogte van onze acties!",
    "Entrez votre email": "Vul je e-mailadres in",
    "À Propos": "Over ons",
    "Contacter le SAV sur WhatsApp": "Klantenservice via WhatsApp",
    "Offre de bienvenue": "Welkomstaanbieding",
    "-10 % supplémentaire sur ta 1re commande": "Extra -10% op je eerste bestelling",
    "-10 % sur ta 1re commande avec le code": "-10% op je eerste bestelling met de code",
    ", à saisir au paiement": ", in te voeren bij het afrekenen",
    "À cumuler avec les soldes. Code à saisir au moment du paiement.": "Te combineren met de uitverkoop. Code invoeren bij het afrekenen.",
    "Copier le code": "Code kopiëren",
    "Code copié": "Code gekopieerd",
    "Code :": "Code:",
    "Non merci": "Nee, bedankt",
    "Fermer": "Sluiten",
    "Panier": "Winkelwagen",
    "Ton panier est vide.": "Je winkelwagen is leeg.",
    "Fermer le panier": "Winkelwagen sluiten",
    "-10% avec le code": "-10% met de code",
    "sur votre première commande": "op je eerste bestelling",
    "1 PAIRE ACHETÉE LA DEUXIÈME À -25% !": "1 PAAR GEKOCHT, HET TWEEDE -25%!",
    "Plus que": "Nog maar",
    "1 paire": "1 paar",
    "2 paires": "2 paar",
    "3 paires": "3 paar",
    "pour débloquer": "om te ontgrendelen",
    "Tous tes avantages sont débloqués.": "Al je voordelen zijn ontgrendeld.",
    "Offre pack": "Pakketaanbieding",
    "COMPLÈTE TON PACK": "MAAK JE PACK COMPLEET",
    "2e paire à -25%": "2e paar -25%",
    "3e paire : chaussettes + kit": "3e paar: sokken + kit",
    "Choisis ta 2e paire": "Kies je 2e paar",
    "Choisis ta 3e paire": "Kies je 3e paar",
    "Choisis un modèle et une taille": "Kies een model en een maat",
    "Choisir la taille": "Kies je maat",
    "Ou cherche un autre modèle…": "Of zoek een ander model…",
    "+ cadeau offert dès 139 €": "+ gratis cadeau vanaf € 139",
    "Remise -25% appliquée automatiquement au panier sur la paire la moins chère. Cumulable avec les paliers de fidélité.": "De korting van -25% wordt automatisch in de winkelwagen toegepast op het goedkoopste paar. Te combineren met de loyaliteitsdrempels.",
    "Livraison offerte, expédition sous 24 à 72 h.": "Gratis levering, verzending binnen 24 tot 72 uur.",
    "Chaussettes ou kit offert": "Gratis sokken of kit",
    "Chaussettes + kit offerts": "Gratis sokken + kit",
    "Kit offert + tes chaussettes au choix": "Gratis kit + sokken naar keuze",
    "Choisis ta taille pour recevoir tes chaussettes": "Kies je maat om je sokken te ontvangen",
    "Ton cadeau au choix": "Jouw cadeau naar keuze",
    "Panier réservé pendant": "Winkelwagen gereserveerd voor",
    "Payez en": "Betaal in",
    "3 ou 4 fois": "3 of 4 termijnen",
    "avec Klarna": "met Klarna",
    "Paiement 100 % sécurisé": "100% veilig betalen",
    "Code promo": "Kortingscode",
    "Entre ton code promo": "Vul je kortingscode in",
    "Appliquer": "Toepassen",
    "Annuler": "Annuleren",
    "Sous-total": "Subtotaal",
    "Commander": "Afrekenen",
    "Enlever": "Verwijderen",
    "Offert": "Gratis",
    "Kit KICK CARE — Offert": "KICK CARE Kit — Cadeau",
    "Chaussettes Nike — Offertes": "Nike Sokken — Cadeau",
    "Réduire ou étendre le bas du panier": "Onderkant van de winkelwagen in- of uitklappen",
    "Voir ou masquer les avantages et le pack": "Voordelen en pack tonen of verbergen",
    "Voir le panier": "Bekijk winkelwagen"
  };

  var DAYS = { 'dim.': 'zo', 'lun.': 'ma', 'mar.': 'di', 'mer.': 'wo', 'jeu.': 'do', 'ven.': 'vr', 'sam.': 'za' };
  var MONTHS = { 'janv.': 'jan.', 'févr.': 'feb.', 'mars': 'mrt.', 'avr.': 'apr.', 'mai': 'mei', 'juin': 'jun.', 'juil.': 'jul.', 'août': 'aug.', 'sept.': 'sep.', 'oct.': 'okt.', 'nov.': 'nov.', 'déc.': 'dec.' };

  var RULES = [
    [/^(\d+) modèles?$/, function (m, n) { return n + (n === '1' ? ' model' : ' modellen'); }],
    [/^• (\d+) avis$/, function (m, n) { return '• ' + n + ' reviews'; }],
    [/^(\d+) avis$/, function (m, n) { return n + ' reviews'; }],
    [/^Vous Économisez (.+)$/i, function (m, v) { return 'Je bespaart ' + v; }],
    [/^Noté (.+)$/, function (m, v) { return 'Beoordeeld met ' + v; }],
    [/^J\+(\d+) à J\+(\d+)$/, function (m, a, b) { return 'Dag ' + a + ' tot ' + b; }],
    [/^(\d+) paires$/, function (m, n) { return n + ' paar'; }],
    [/(dim\.|lun\.|mar\.|mer\.|jeu\.|ven\.|sam\.)/g, function (m) { return DAYS[m]; }, true],
    [/\b(janv\.|févr\.|mars|avr\.|mai|juin|juil\.|août|sept\.|oct\.|nov\.|déc\.)(?=\s|$)/g, function (m) { return MONTHS[m]; }, true],
    [/(\d+) h (\d+) min/g, function (m, h, mi) { return h + 'u ' + mi + 'min'; }, true]
  ];

  function tr(raw) {
    var t = raw.replace(/\s+/g, ' ').trim();
    if (!t) return null;
    if (Object.prototype.hasOwnProperty.call(DICT, t)) return DICT[t];
    var out = t, changed = false;
    for (var i = 0; i < RULES.length; i++) {
      var r = RULES[i];
      if (r[2]) {
        var nx = out.replace(r[0], r[1]);
        if (nx !== out) { out = nx; changed = true; }
      } else if (r[0].test(out)) {
        out = out.replace(r[0], r[1]); changed = true; break;
      }
    }
    return changed ? out : null;
  }

  var SKIP = 'script,style,noscript,textarea,code,pre,[contenteditable],.product__description,.sf-product-description,[data-nk-noi18n]';
  function doText(node) {
    var p = node.parentElement;
    if (!p || p.closest(SKIP)) return;
    var v = node.nodeValue;
    var res = tr(v);
    if (res === null) return;
    var lead = v.match(/^\s*/)[0], trail = v.match(/\s*$/)[0];
    var next = lead + res + trail;
    if (next !== v) node.nodeValue = next;
  }
  var ATTRS = ['placeholder', 'aria-label', 'title'];
  function doAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute && el.getAttribute(ATTRS[i]);
      if (!v) continue;
      var res = tr(v);
      if (res !== null && res !== v) el.setAttribute(ATTRS[i], res);
    }
    if (el.tagName === 'INPUT' && /^(submit|button)$/i.test(el.type) && el.value) {
      var rv = tr(el.value); if (rv !== null) el.value = rv;
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType !== 1 || root.closest && root.closest(SKIP)) return;
    doAttrs(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) doText(n); else doAttrs(n);
    }
  }

  var busy = false;
  function observe() {
    new MutationObserver(function (list) {
      if (busy) return;
      busy = true;
      try {
        for (var i = 0; i < list.length; i++) {
          var m = list[i];
          if (m.type === 'characterData') doText(m.target);
          else if (m.type === 'attributes') doAttrs(m.target);
          else for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
        }
      } finally { busy = false; }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }

  function boot() { walk(document.body); observe(); document.documentElement.classList.add('nk-i18n-ready'); }
  if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
